import Cookies from 'js-cookie';
import { buildApp } from '../app';
import { DanflossBuildSwitcher } from './brandSwitcher';

try {
  Cookies.remove('sessionId');
} catch (e) {
  console.error('Failed to remove sessionId cookie:', e);
}

buildApp(DanflossBuildSwitcher, {});
